import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setCountries,
  setLanguages,
  setTranslation,
} from '@/redux/app/appSlice';

import appService from '@/services/appService';

const LANGUAGES = ['en', 'ru', 'es', 'pt', 'fa', 'hi', 'ar'];

const getCountries = () => async dispatch => {
  try {
    const data = await appService.getCountries();

    dispatch(setCountries(data));
  } catch (e) {
    Notify.failure(
      e?.response?.data?.message || 'Request GetCountries failure',
    );
  }
};

const getLanguages = () => async dispatch => {
  try {
    const data = await appService.getLanguages();

    const languages = data
      .filter(({ code }) => LANGUAGES.includes(code))
      .map(({ id, name, code }) => ({ id, name, code }));

    dispatch(setLanguages(languages));
  } catch (e) {
    Notify.failure(
      e?.response?.data?.message || 'Request GetLanguages failure',
    );
  }
};

const getTranslation = params => async dispatch => {
  try {
    const data = await appService.getTranslation(params);

    dispatch(setTranslation(data));
  } catch (e) {
    Notify.failure(
      e?.response?.data?.message || 'Request GetTranslation failure',
    );
  }
};

const setLanguage = async params => {
  try {
    await appService.setLanguage(params);
  } catch (e) {
    Notify.failure(e?.response?.data?.message || 'Request SetLanguage failure');
  }
};

export default {
  getCountries,
  getLanguages,
  getTranslation,
  setLanguage,
};
